'use client'

// imports
;!function(){try{var e="undefined"!=typeof window?window:"undefined"!=typeof global?global:"undefined"!=typeof globalThis?globalThis:"undefined"!=typeof self?self:{};e._sentryModuleMetadata=e._sentryModuleMetadata||{},e._sentryModuleMetadata[(new e.Error).stack]=Object.assign({},e._sentryModuleMetadata[(new e.Error).stack],{"_sentryBundlerPluginAppKey:dotorg-next":true});}catch(e){}}();import { Splide, SplideSlide, Options } from '@splidejs/react-splide';

// lib files
import { ShowRowContent } from '@/lib/types/api/show-data';

// constants
import { DEFAULT_SPLIDE_OPTIONS } from '@/lib/constants';

// components
import ContentRowTitleDescription from '@/components/ContentRowTitleDescription/ContentRowTitleDescription';
import ShowPoster, { ShowBadgeFlags } from '@/components/ShowPoster/ShowPoster';

// styles
import '@splidejs/splide/dist/css/splide.min.css';
import showRowSplideStyles from './ShowRowSplide.module.scss';
import styles from './ShowRow.module.scss';
export interface TopTenShowRowProps {
  shows: ShowRowContent[];
  title?: string;
  showBadgeFlags?: ShowBadgeFlags;
}

export default function TopTenShowRow(props: TopTenShowRowProps) {
  const { showBadgeFlags, title } = props;

  // only take 10 shows
  const shows = props.shows.slice(0, 10);

  const options: Options = {
    ...DEFAULT_SPLIDE_OPTIONS,
    perPage: 2,
    gap: '0px',
    breakpoints: {
      600: {
        perPage: 3,

      },
      768: {
        perPage: 4,
      },
      1280: {
        perPage: 5,
      }
    },
    classes: {
      list: `splide__list ${showRowSplideStyles.splide__list}`,
      arrow: `splide__arrow ${showRowSplideStyles.splide__arrow}`
    }
  }

  return (
    <div className={`${styles.show_row} ${styles.top_ten_show_row}`}>
      {title && (
        <ContentRowTitleDescription title={title} />
      )}

      <Splide aria-label='Show Row' options={options} >
        {shows.map((show, index) => (
          <SplideSlide key={show.slug} className={styles.splide__slide}>
            <div className={styles.top_ten_item}>
              <span className={styles.top_ten_item__count}>{index+1}</span>
              <div className={styles.top_ten_item__poster_container}>
                <ShowPoster show={show} showBadgeFlags={showBadgeFlags} className={styles.show_row__show_poster} />
              </div>
            </div>
          </SplideSlide>
        ))}
      </Splide>
    </div>
  )
}
